import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { currencies } from '../data/currencies';

const CurrencySwitcher = ({ selectedCurrency, onCurrencyChange }) => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleCurrencySelect = (currencyCode) => {
    onCurrencyChange(currencyCode);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const currentCurrencyInfo = currencies.find(c => c.code === selectedCurrency);
  
  const sortedCurrencies = useMemo(() => {
    const priorityCodes = ['EUR', 'USD', 'TRY'];
    const priorityCurrencies = currencies.filter(c => priorityCodes.includes(c.code))
        .sort((a, b) => priorityCodes.indexOf(a.code) - priorityCodes.indexOf(b.code));
    const otherCurrencies = currencies.filter(c => !priorityCodes.includes(c.code))
        .sort((a, b) => t(a.nameKey).localeCompare(t(b.nameKey), i18n.language));
    return [...priorityCurrencies, ...otherCurrencies];
  }, [i18n.language, t]);

  return (
    <div className="language-dropdown currency-switcher" ref={dropdownRef}>
      <button className="dropdown-toggle" onClick={() => setIsOpen(!isOpen)}>
        <span>{currentCurrencyInfo.code} - {currentCurrencyInfo.symbol}</span>
        <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'}`}></i>
      </button>

      {/* DÜZELTME: Artık 'large' ve 'currency-grid' sınıfları yok, basit bir 'ul' var */}
      {isOpen && (
        <ul className="dropdown-menu currency-menu">
          {sortedCurrencies.map((currency) => (
            <li
              key={currency.code}
              onClick={() => handleCurrencySelect(currency.code)}
              className={selectedCurrency === currency.code ? 'active' : ''}
            >
              {t(currency.nameKey)} - {currency.code}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CurrencySwitcher;